import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { Card, CardContent, Grid, Paper, WithStyles, withStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { styles } from "../../CardsView.styles";
import CategoryIcon from "@material-ui/icons/Category";
import StoreIcon from "@material-ui/icons/Store";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { CenteredContainer } from "../../../components/CenteredContainer/CenteredContainer";
import { PageBanner } from "../../../components/PageBanner/PageBanner";
import { isPermissionGranted } from "../../../../utilities/permissionUtils";
import { useGetRoles } from "../../../../hooks/useGetRole";
import { Permission } from "../../../../constants/PERMISSIONS";

export interface IContractMenuViewProps extends WithStyles<typeof styles> {}

const ContractMenuViewPure: React.FunctionComponent<IContractMenuViewProps> = ({ classes }) => {
    interface ICard {
        icon: JSX.Element;
        title: string;
        path: string;
        scope?: Permission | Permission[];
    }
    const cards: ICard[] = [
        {
            icon: <CategoryIcon />,
            title: "Contract types",
            path: "/admin/contracts/types",
            scope: ["contracts.read", "contracts.write"]
        },
        {
            icon: <StoreIcon />,
            title: "Information products",
            path: "/admin/contracts/products",
            scope: ["contracts.read", "contracts.write"]
        },
        {
            icon: <SyncAltIcon />,
            title: "Information Product vs. Subscription Type relation",
            path: "/admin/contracts/products-subscriptions",
            scope: ["contracts.read", "contracts.write"]
        }
    ];

    const roles = useGetRoles();

    return (
        <>
            <PageBanner title="Contracts" isPublic={false} />
            <CenteredContainer>
                <Paper elevation={0} className={classes.box}>
                    <div className={classes.title}>
                        <Typography variant="h3" className={classes.header}>
                            Contracts
                        </Typography>
                    </div>
                    <Grid container spacing={3} direction="row" alignItems="center">
                        {cards
                            .filter(card => !card.scope || isPermissionGranted(roles, card.scope))
                            .map((card, i) => (
                                <Grid item xs={12} sm={4} key={i}>
                                    <NavLink to={card.path} style={{ textDecoration: "none" }}>
                                        <Card className={classes.card}>
                                            <CardContent className={classes.cardContent}>
                                                {card.icon}
                                                <span className={classes.cardTitle}>{card.title}</span>
                                            </CardContent>
                                        </Card>
                                    </NavLink>
                                </Grid>
                            ))}
                    </Grid>
                </Paper>
            </CenteredContainer>
        </>
    );
};

export const ContractMenuView = withStyles(styles)(ContractMenuViewPure);
